export function useCartDataProvider() {
	let isGuest = true;
	let isFastBuy = true;
	let isFakePayment = false;

	const $cartDataProvider = document.getElementById("cart-data-provider");
	if (!$cartDataProvider) throw new Error("Не удалось найти #cart-data-provider");
	isGuest = !!$cartDataProvider.dataset.isGuest;
	isFastBuy = !!$cartDataProvider.dataset.isFastBuy;
	isFakePayment = !!$cartDataProvider.dataset.isFake;

	return {
		isGuest,
		isFastBuy,
		isFakePayment,
	};
}
